import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-14" data-id="element-96" data-mp="4vrzzwt0kbqc">
      <Reveal className="mx-auto flex max-w-3xl flex-col items-center gap-4 rounded-3xl border-2 border-gold-bright bg-surface p-7 text-center md:p-10" data-id="element-97" data-mp="9wfqmhdbyqk1">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-gold-soft" data-id="element-98" data-mp="jtc0orivnkqp">
          <ShieldCheckIcon size={30} className="text-gold" data-id="element-99" data-mp="ntcd66mf1lv4" />
        </span>
        <h2 id="garantia" className="font-display text-3xl md:text-4xl font-bold uppercase text-ink" data-id="element-100" data-mp="sl47ms8p0bqj">
          Garantía de 7 días
        </h2>
        <p className="font-script text-3xl text-gold" data-id="element-101" data-mp="xm1movyeopnt">
          Probalo con tranquilidad
        </p>
        <p className="mx-auto max-w-2xl text-sm md:text-base leading-relaxed text-ink-muted" data-id="element-102" data-mp="12gxje9el8179">
          Accedé al material, explorá los módulos y comenzá a utilizarlo. Si
          dentro de los primeros 7 días considerás que no cumple con lo
          ofrecido,{' '}
          <span className="font-semibold text-ink" data-id="element-103" data-mp="20s2kwrhbyihm">
            podés solicitar tu devolución
          </span>{' '}
          según las condiciones de compra.
        </p>
        <p className="text-sm font-bold uppercase tracking-[0.18em] text-cta" data-id="element-104" data-mp="1rsnwryomyk0a">
          Tu compra está protegida
        </p>
      </Reveal>
    </section>;
}